module.exports = __webpack_public_path__ + "static/img/KP.9406b479.svg";